<template>
  <div class="container mw-960" slot="layout-body">
    <div class="error-container text-center">
      <img src="@/assets/images/signin-lcic-inactive.svg">
      <div class="typography-headline-6">
        일시적인 문제가 발생해서 잠시 후에 다시 시도해주세요.<br />
        문제가 지속되면 클래스팅 고객센터로 연락 주세요.
      </div>
      <div class="link-wrapper">
        <a @click="$router.go(-1)">
          이전 페이지로 돌아가기
        </a>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'forbidden',
};
</script>
